export default __webpack_public_path__ + "static/media/qr_code1.dde1ae51.png";